import React, { PropsWithChildren, useCallback } from 'react';
import styles from './styles.module.scss';

interface TableScoreRowProps {
  isCompact?: boolean;
  par: number;
  score: number;
  currentlySelectedIndex?: number;
  index?: number;
  isTotal?: boolean;
  showOverlay?: boolean;
}

const USGAScoreRow: React.FC<PropsWithChildren<TableScoreRowProps>> = ({
  isCompact = true,
  par,
  score,
  showOverlay,
  children,
}) => {
  const getContainerForScore = useCallback(
    (par: number, score: number, children: React.ReactNode) => {
      if (score <= par - 2) {
        return (
          <div className={styles.outer_circle}>
            <div className={styles.inner_circle}>
              {children}
            </div>
          </div>
        );
      }

      if (score === par - 1) {
        return (
          <div className={styles.outer_circle}>
            {children}
          </div>
        );
      }

      if (score === par + 1) {
        return (
          <div className={styles.outer_square}>
            {children}
          </div>
        );
      }

      if (score >= par + 2) {
        return (
          <div className={styles.outer_square}>
            <div className={styles.inner_square}>
              {children}
            </div>
          </div>
        );
      }

      return children;
    },
    [isCompact],
  );

  return (
    <>
      {showOverlay
        ? getContainerForScore(par, score, children)
        : children}
    </>
  );
};

export default USGAScoreRow;
